import React, { useMemo } from 'react';
import {
  Category,
  EmptyListNoStudiesFoundInStage,
} from './EmptyList/StudyListEmptyState';
import StudyList, { FetchNextPageFunction, Study } from './StudyList';
import { LoadMoreButton } from './LoadMoreButton';
import { ReachedMaxAIResults } from './ReachedMaxAIResults';
import { StudyReferenceFilesProvider } from './components/StudyReferenceFilesProvider';
import { Stack } from 'components/layout/Stack/Stack';

const StudyListWithEmptyStateManagement: React.FC<{
  reviewId: string;
  category: Category;
  studies: Study[];
  item: (study: Study) => React.ReactNode;
  fetchNextPage?: FetchNextPageFunction;
  hasNextPage?: boolean;
  hasReachedMaxAIResults?: boolean;
  pageSize: number;
}> = ({
  reviewId,
  studies,
  item,
  category,
  fetchNextPage,
  hasNextPage,
  hasReachedMaxAIResults,
  pageSize,
}) => {
  const studyItems = useMemo(() => studies.map((study) => item(study)), [
    studies,
    item,
  ]);

  if (studyItems.length === 0) {
    return <EmptyListNoStudiesFoundInStage category={category} />;
  }

  return (
    <StudyList>
      <StudyReferenceFilesProvider
        category={category}
        reviewId={reviewId}
        studies={studies}
        pageSize={pageSize}
      >
        <Stack spacing={3} className="study-list-items">
          {studyItems}
        </Stack>
      </StudyReferenceFilesProvider>

      {fetchNextPage && hasNextPage && (
        <LoadMoreButton
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
        />
      )}

      {hasReachedMaxAIResults && (
        <ReachedMaxAIResults hasReachedMaxAIResults={hasReachedMaxAIResults} />
      )}
    </StudyList>
  );
};

export default StudyListWithEmptyStateManagement;
